const songsById = new Map();

export function listStoredSongs() {
    return Promise.resolve(Array.from(songsById.values()));
}

export function getStoredSong(songId) {
    return Promise.resolve(songsById.get(songId) || null);
}

export function putStoredSong(songRecord) {
    songsById.set(songRecord.id, songRecord);
    return Promise.resolve(songRecord);
}

export function removeStoredSong(songId) {
    songsById.delete(songId);
    return Promise.resolve();
}

export function clearStoredSongs() {
    songsById.clear();
    return Promise.resolve();
}